import dayjs from 'dayjs';
import _ from 'lodash';
import checkPermission from './permission';
import store from '@/store';
import { fileDownload, previewPdf, previewOffice } from '@/utils/common';
import * as client from '@/api';
export default (Vue) => {
    Vue.prototype._ = _;
    Vue.prototype.$enum = code => store.dispatch('getEnumList', code);
    Vue.prototype.$authCheck = checkPermission;
    Vue.prototype.$dayjs = dayjs;
    Vue.prototype.$client = client;
    Vue.prototype.$utils = {
        fileDownload,
        previewPdf,
        previewOffice
    };
};
